import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTopRender from "./Components/Shared/ScrollToTop_render";
import "./assets/css/plugins.css";
import "./assets/css/style.css";
import "./assets/css/skin-1.css";
import "./assets/css/templete.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Home from "./Components/Pages/Home/Home";
import Reservation from "./Components/Pages/Reservation/Reservation";
import ReservationV2 from "./Components/Pages/ReservationV2/ReservationV2";
import BookingPage from "./Components/Pages/ReservationV2/BookingPage";
import JoinPage from "./Components/Pages/ReservationV2/JoinPage";
import ReservationDetailPage from "./Components/Pages/MyReservation/ReservationDetailPage";
import Tournois from "./Components/Pages/Tournois/Tournois";
import Contact from "./Components/Pages/Contact/Contact";
import ErrorNotFound from "./Components/Pages/Error/Error";
import Login from "./Components/Pages/Login/Login";
import Register from "./Components/Pages/Register/Register";
import VerifyEmailSent from "./Components/Pages/VerifyEmailSent/VerifyEmailSent";
import VerifyEmail from "./Components/Pages/VerifyEmail/VerifyEmail";
import { useAddToHomescreenPrompt } from "./PWA/AddToHomeScreen";
import ProtectedRoutes from "./ProtectedRoutes";
import "react-toastify/dist/ReactToastify.css";
import { refreshUserUser } from "./Store/userSlice";
import { useDispatch } from "react-redux";
import TournamentEvent from "./Components/Pages/Tournois/TournamentEvent/TournamentEvent";
import axios from "axios";
import ForgotPass from "./Components/Pages/ForgotPass/ForgotPass";
import ResetPass from "./Components/Pages/ResetPass/ResetPass";
import InvalidToken from "./Components/Pages/ResetPass/InvalidToken";
import DocumentMeta from "react-document-meta";
import LoginProtectedRoutes from "./LoginProtectedRoutes";
import MyReservation from "./Components/Pages/MyReservation/MyReservation";
import UserAccount from "./Components/Pages/UserAccount/UserAccount";
import ChangePassword from "./Components/Pages/ChangePassword/ChangePassword";
import MainLayout from "./Components/layout/MainLayout";
import AuthLayout from "./Components/layout/AuthLayout";

// Axios HTTP Request defaults
axios.defaults.baseURL = process.env.REACT_APP_BACK_END_BASE_URL;

function App() {
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const dispatch = useDispatch();

  function getPWADisplayMode() {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (document.referrer.startsWith("android-app://")) {
      setIsAppInstalled(true);
    } else if (navigator.standalone || isStandalone) {
      setIsAppInstalled(false);
    } else {
      setIsAppInstalled(true);
    }
  }

  useEffect(() => {
    getPWADisplayMode();
    let accessToken = localStorage.getItem("token");
    if (accessToken) {
      dispatch(refreshUserUser()).then((result) => {});
    }

    if (window.navigator.standalone) {
      setIsAppInstalled(true);
    }
  }, []);

  const handleInstallClick = () => {
    if (prompt) {
      promptToInstall();
    } else {
      alert(
        'To install this app, tap the Share button and then "Add to Home Screen".'
      );
    }
  };

  const meta = {
    title: "Casa del Padel - Club de Padel à Sfax, Tunisie",
    description:
      "Découvrez Casa del Padel, votre club de padel à Sfax, Tunisie. Rejoignez-nous pour des matchs passionnants et des cours de padel adaptés à tous les niveaux.",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "casadelpadel.tn, padel Sfax, padel Tunisie, padel",
      },
    },
    property: {
      "og:title": "Casa del Padel - Club de Padel à Sfax, Tunisie",
      "og:description":
        "Découvrez Casa del Padel, votre club de padel à Sfax, Tunisie. Rejoignez-nous pour des matchs passionnants et des cours de padel adaptés à tous les niveaux.",
      "og:url": "https://www.casadelpadel.tn",
    },
  };

  return (
    <DocumentMeta {...meta}>
      <div className="App">
        <Router>
          <ScrollToTopRender />
          <Routes>
            {/* Main layout: persistent Header + Footer */}
            <Route element={<MainLayout />}>
              <Route exact path="/" element={<Home />} />
              <Route exact path="contact" element={<Contact />} />
              <Route path="*" element={<ErrorNotFound />} />
              <Route element={<ProtectedRoutes />}>
                <Route exact path="reservation" element={<Navigate replace to="/reservation-v2" />} />
                <Route exact path="reservation-v2" element={<ReservationV2 />} />
                <Route exact path="reservation-v2/book" element={<BookingPage />} />
                <Route exact path="reservation/join/:id" element={<JoinPage />} />
                <Route exact path="tournois" element={<Tournois />} />
                <Route
                  exact
                  path="tournois/event/:eventID"
                  element={<TournamentEvent />}
                />
                <Route exact path="my-reservation" element={<MyReservation />} />
                <Route exact path="my-reservation/:id" element={<ReservationDetailPage />} />
                <Route exact path="profile" element={<UserAccount />} />
                <Route exact path="change-password" element={<ChangePassword />} />
              </Route>
            </Route>

            {/* Auth layout: persistent Header, no Footer */}
            <Route element={<AuthLayout />}>
              <Route element={<LoginProtectedRoutes />}>
                <Route exact path="login" element={<Login />} />
                <Route exact path="register" element={<Register />} />
                <Route exact path="forgot-pass" element={<ForgotPass />} />
                <Route exact path="reset-password" element={<ResetPass />} />
                <Route exact path="invalid-token" element={<InvalidToken />} />
                <Route exact path="verify-email-sent" element={<VerifyEmailSent />} />
                <Route exact path="verify-email" element={<VerifyEmail />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </div>
    </DocumentMeta>
  );
}

export default App;
